import React, { useState, useEffect } from 'react';
import { Card, Nav } from 'react-bootstrap';
import {
  ApprovalPenerimaanPettyCash,
  HistoryApprovalPenerimaanPettyCash,
} from './Tabs';

const MainApprovalPenerimaanPettyCash = ({ setNavbarTitle }) => {
  const [tabs, setTabs] = useState('approval'); //State untuk menampung tabs yang aktif

  // Konfigurasi komponen tabs
  const tabsConfig = [
    {
      tab: 'approval',
      label: 'Approval',
      component: () => <ApprovalPenerimaanPettyCash />,
    },
    {
      tab: 'history',
      label: 'History',
      component: () => <HistoryApprovalPenerimaanPettyCash />,
    },
  ];

  // Menangani perubahan pada tabs
  const onTabsChangeHandler = (e, newPage) => {
    e.preventDefault();
    setTabs(newPage);
  };

  useEffect(() => {
    setTabs(tabsConfig[0].tab);
  }, []);

  useEffect(() => {
    setNavbarTitle('Approval Penerimaan Petty Cash');
    return () => {};
  }, []);

  const TabsNav = ({ tab, label }) => (
    <Nav.Item>
      <Nav.Link href={`#${tab}`} onClick={(e) => onTabsChangeHandler(e, tab)}>
        {label}
      </Nav.Link>
    </Nav.Item>
  );

  return (
    <Card>
      <Card.Header>
        <Nav variant="tabs" defaultActiveKey={`#${tabs}`}>
          {tabsConfig.map((val, index) => (
            <TabsNav key={index} tab={val.tab} label={val.label} />
          ))}
        </Nav>
      </Card.Header>
      <Card.Body>
        {tabsConfig.map(
          ({ tab, component: Component }, index) =>
            tab === tabs && <Component key={index} />
        )}
      </Card.Body>
    </Card>
  );
};

export default MainApprovalPenerimaanPettyCash;
